/* Emergency Water Survival Pack — interactivity: countdown, FAQ, sticky CTA, ATC + cart drawer */
(function () {
  function init(root) {
    if (!root || root.dataset.ewspInit) return;
    root.dataset.ewspInit = '1';

    var cfgEl = root.querySelector('[data-ewsp-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    var variantId = cfg.variantId || '';
    var moneyFormat = cfg.moneyFormat || '${{amount}}';

    /* ---------- Countdown to end of day ---------- */
    var h = root.querySelector('#ewsp-cd-h'),
        m = root.querySelector('#ewsp-cd-m'),
        s = root.querySelector('#ewsp-cd-s');
    if (h && m && s) {
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var now = new Date(), end = new Date(now);
        end.setHours(23, 59, 59, 999);
        var d = Math.max(0, Math.floor((end - now) / 1000));
        h.textContent = pad(Math.floor(d / 3600));
        m.textContent = pad(Math.floor((d % 3600) / 60));
        s.textContent = pad(d % 60);
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---------- FAQ accordion ---------- */
    root.querySelectorAll('.ewsp-faq').forEach(function (item) {
      var btn = item.querySelector('.ewsp-faq-q'),
          sign = item.querySelector('.ewsp-faq-sign');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        root.querySelectorAll('.ewsp-faq').forEach(function (o) {
          o.classList.remove('open');
          var sg = o.querySelector('.ewsp-faq-sign'); if (sg) sg.textContent = '+';
          var b = o.querySelector('.ewsp-faq-q'); if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          if (sign) sign.textContent = '−';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---------- Sticky mobile CTA ---------- */
    var sticky = root.querySelector('.ewsp-sticky');
    if (sticky) {
      var shown = false;
      window.addEventListener('scroll', function () {
        var next = window.scrollY > 760;
        if (next !== shown) { shown = next; sticky.classList.toggle('show', next); }
      }, { passive: true });
    }

    /* ---------- Cart drawer ---------- */
    var overlay = root.querySelector('.ewsp-drawer-overlay');
    var drawer = root.querySelector('.ewsp-drawer');
    var drawerBody = root.querySelector('.ewsp-drawer-body');
    var drawerSub = root.querySelector('.ewsp-drawer-sub .v');

    function fmtMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
                        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    function openDrawer() {
      if (overlay) overlay.classList.add('open');
      if (drawer) drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (overlay) overlay.classList.remove('open');
      if (drawer) drawer.classList.remove('open');
      document.body.style.overflow = '';
    }
    if (overlay) overlay.addEventListener('click', closeDrawer);
    root.querySelectorAll('[data-ewsp-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    function renderCart(cart) {
      if (!drawerBody) return;
      if (!cart.items || !cart.items.length) {
        drawerBody.innerHTML = '<div class="ewsp-drawer-empty">Your cart is empty.</div>';
        if (drawerSub) drawerSub.textContent = fmtMoney(0);
        return;
      }
      var html = '';
      cart.items.forEach(function (it) {
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '<img alt="">';
        html += '<div class="ewsp-drawer-item">' + img +
                '<div><div class="nm">' + it.product_title + '</div>' +
                '<div class="qty">Qty ' + it.quantity + '</div></div>' +
                '<div class="pr">' + fmtMoney(it.final_line_price) + '</div></div>';
      });
      drawerBody.innerHTML = html;
      if (drawerSub) drawerSub.textContent = fmtMoney(cart.total_price);
    }

    function refreshAndOpen() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); openDrawer(); })
        .catch(function () { openDrawer(); });
    }

    function addToCart(btn) {
      var note = btn.parentNode.querySelector('.ewsp-cta-note');
      function setNote(msg, cls) {
        if (!note) return;
        note.textContent = msg || '';
        note.className = 'ewsp-cta-note' + (cls ? ' ' + cls : '');
      }
      if (!variantId) {
        setNote('Connect a product in the theme editor to enable checkout.', 'err');
        return;
      }
      var original = btn.innerHTML;
      btn.setAttribute('disabled', 'disabled');
      btn.innerHTML = 'Adding…';
      setNote('', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        btn.removeAttribute('disabled');
        btn.innerHTML = original;
        if (res.ok) {
          refreshAndOpen();
        } else {
          setNote((res.data && res.data.description) || 'This product is not available yet.', 'err');
        }
      }).catch(function () {
        btn.removeAttribute('disabled');
        btn.innerHTML = original;
        setNote('Something went wrong. Please try again.', 'err');
      });
    }

    root.querySelectorAll('[data-ewsp-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.ewsp').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify theme editor support
  document.addEventListener('shopify:section:load', boot);
})();
